module.exports = __webpack_public_path__ + "img/chat-bg.60bc543c.jpg";